/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { NotificationManager } from "react-notifications";
import { useDropzone } from "react-dropzone";
import type { ApiResponse, appConfigs, RootState } from "../types/types";
import { HugeiconsIcon } from "@hugeicons/react";
import CustomDataTable from "../CustomDataTable/CustomDataTable";
//@ts-ignore
import { Image02Icon } from "@hugeicons-pro/core-solid-standard";
//@ts-ignore
import { Copy01StrokeStandard } from "@hugeicons-pro/core-stroke-standard";
import { styled } from "@mui/material/styles";
import type { TooltipProps } from "@mui/material/Tooltip";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { Box, IconButton,InputAdornment,LinearProgress,TextField } from "@mui/material";
//@ts-ignore
import { Delete03Icon } from "@hugeicons-pro/core-stroke-standard";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { gettemplateImageList,updatetemplateimages } from 'src/services/templateService';
//@ts-ignore
import {MultiplicationSignStrokeStandard} from '@hugeicons-pro/core-stroke-standard';
import {
  aiValidationWakeup,
  aiValidationValidateHtml,
} from 'src/services/aiValidationService';
import { useSelector } from "react-redux";
import GradientButton from "../MUICustomButton/GradientButton";
import Loader from '../Loader';
import CircularProgress from "@mui/material/CircularProgress";
//@ts-ignore
import { Tick02Icon,Cancel01Icon,ViewStrokeRounded} from "@hugeicons-pro/core-stroke-rounded";
import { CANCEL_TEMPLATE, EDIT_TEMPLATE, LABEL_BTN_CANCEL, SAVE_TEMPLATE } from "src/constants/constant";

interface PropsType {
  closeModal: () => void;
  imageData: {src: string; alt: string}[];
  onFilesUpload: (files: UploadedFile[]) => void;
  updateEditorContent?: (newHtml: string) => void;
  templateIdentifier?:string | null;
  TemplateName?:string | null;
  editorContent: string;
  templateActiveVersionData?:number | 1;

}
interface UploadedFile {
  id: string;
  file?: File;
  preview: string;
  url: string;
  size: string;
}


interface imageDataFile {
  id: string;
  preview: string; 
  url: string; 
  size: string;
  alt: string;
 }
const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props}  classes={{ popper: className }} placement="bottom" />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: { backgroundColor: theme.palette.common.black },
  [`& .${tooltipClasses.arrow}`]: {
    display: "none",
  },
}));
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));
function TemplateImageUpload({ closeModal, imageData, onFilesUpload, updateEditorContent,templateIdentifier,templateActiveVersionData,TemplateName,editorContent }: PropsType): JSX.Element {
  const [maxFileSize, setMaxFileSize] = useState<number>(0);
  const [maxFileSizeDisplay, setMaxFileSizeDisplay] = useState<number>(0);
  const [allowedExtensions, setAllowedExtensions] = useState<string[]>([]);
  const [allowedMimeTypes, setAllowedMimeTypes] = useState<string[]>([]);
  const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);
  const [newImagData, setNewImagData] = useState<imageDataFile[]>([]);
  const [formattedExistingImages, setFormattedExistingImages] = useState<UploadedFile[]>([]);
  const [showImagePreviewModal, setShowImagePreviewModal] = useState<boolean>(false);
  const [previewImageUrl, setPreviewImageUrl] = useState<string>("");
  const [extensionsDisplay, setExtensionsDisplay] = useState<string>("");
  const templateGuid = templateIdentifier ?? localStorage.getItem("templateGuid");
   const { user } = useSelector((state: RootState) => state.auth);
   const [loading, setLoading] = useState<boolean>(true)
   const dataFetchedRef = useRef<boolean>(false);
   const [uploadingFiles, setUploadingFiles] = useState<Record<string, boolean>>({});
   const storedAppConfig = localStorage.getItem("appConfigs");
   const parsedAppConfig = (storedAppConfig != null) ? JSON.parse(storedAppConfig) as appConfigs[] : [];
   const imagePublicUrl = parsedAppConfig.find((item) => item.configName === "TemplateImagePublicURL")?.configValue;
   const [maxFileCount, setMaxFileCount] = useState<number>(Infinity);
const [replacedImageIds, setReplacedImageIds] = useState<string[]>([]);
const originalImageDataRef = useRef<imageDataFile[]>([]);
const [editorReplacements, setEditorReplacements] = useState<{ oldUrl: string; newUrl: string }[]>([]);
const [aiValidationInProgress, setAiValidationInProgress] = useState(false);
const isFileUploadInProgress = Object.values(uploadingFiles).some(Boolean);
const isProcessing = aiValidationInProgress || isFileUploadInProgress;

// Fetch template images only once when component mounts
useEffect(() => {
  if (templateGuid != null && !dataFetchedRef.current) {
    dataFetchedRef.current = true;
    void getTemplateListData();
  }
}, [templateGuid]);
const getTemplateListData = async (): Promise<void> => {
  if (templateGuid != null) {
    setLoading(true);

    try {
      const createdBy = user?.id ?? 1;
      const templateVersion = templateActiveVersionData ?? 1;
      const res: ApiResponse = await gettemplateImageList(templateGuid,templateVersion, createdBy);

      if (res.status === 200) {
        //@ts-ignore
        const formattedImages: UploadedFile[] = res.data.data.map((item: { imageUrl: string }) => ({
          id: item.imageUrl,
          preview: item.imageUrl,
          url: item.imageUrl,
          size: "",
        }));

        setFormattedExistingImages(formattedImages);
      } else {
        NotificationManager.error("Failed to fetch images");
      }
    } catch (error) {
      console.error("Error fetching images:", error);
      NotificationManager.error("Unknown error has occurred");
    } finally {
      setLoading(false); // ✅ Hide Loader after fetching
    }
  }
};


  useEffect(() => {
    onFilesUpload(uploadedFiles);
  }, [uploadedFiles, onFilesUpload]);

  useEffect(() => {
    const storedAppConfig = localStorage.getItem("appConfigs");
    if (storedAppConfig != null) {
      try {
        const parsedAppConfig = JSON.parse(storedAppConfig) as appConfigs[];

        const maxSize = parsedAppConfig.find((item) => item.configName === "TemplateMaxFileSize")?.configValue;
        const extensions = parsedAppConfig.find((item) => item.configName === "TemplateImageAllowedExtensions")?.configValue;
        const mimeTypes = parsedAppConfig.find((item) => item.configName === "TemplateImageAllowedMimeTypes")?.configValue;
        const maximumImageCount = parsedAppConfig.find((item) => item.configName === "TemplateImageFileCount")?.configValue;
        const MaxFileSizeDisplay = maxSize != null ? Math.round(parseInt(maxSize) / 1024 / 1024) : 0;
        const maxFileCount = parsedAppConfig.find((item) => item.configName === "TemplateImageFileCount")?.configValue;

        setMaxFileSizeDisplay(MaxFileSizeDisplay);
        if(extensions != undefined || extensions != null){
          setExtensionsDisplay(extensions);
        }
       
        if (maxSize != null) setMaxFileSize(parseInt(maxSize, 10) * 1024); // Convert KB to Bytes
        if (extensions != null)
          setAllowedExtensions(extensions.split(",").map((ext) => ext.trim().toLowerCase().replace(/^\./, "")));
        if (mimeTypes != null) setAllowedMimeTypes(mimeTypes.split(",").map((mime) => mime.trim().toLowerCase()));
        if (maxFileCount != null) setMaxFileCount(parseInt(maxFileCount, 10));
      } catch (error) {
        console.error("Error parsing appConfig data:", error);
      }
    }

    // Transform `imageData` to `newImagData` for display only
    const transformedImages = imageData.map((img) => {
      const filename = img.src.split("/").pop();
      return {
        id: `${filename}-${Date.now()}`,
        preview: img.src,
        url: img.src,
        size: "0 MB",
        alt: img.alt 
      };
    });
    // 💾 Save original references for final save
  originalImageDataRef.current = transformedImages;
    setNewImagData(transformedImages);
  }, []);

  
  const mergedFiles = React.useMemo(() => {
    const existingFilesMap = new Map();
  
    formattedExistingImages.forEach((file) => existingFilesMap.set(file.id, file));
    uploadedFiles.forEach((file) => {
      if (!existingFilesMap.has(file.id)) {
        existingFilesMap.set(file.id, file);
      }
    });
  
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return Array.from(existingFilesMap.values()); // ✅ Ensure files are not removed after upload
  }, [formattedExistingImages, uploadedFiles]);
  

  const onDrop = useCallback(
    async (acceptedFiles: File[]) => {
      const newFiles: UploadedFile[] = [];
      const errorMessages: string[] = [];
      
      // Check if too many files are selected
      if (acceptedFiles.length > maxFileCount) {
        NotificationManager.error(`You can only upload up to ${maxFileCount} files at a time.`);
        return;
      }
      
      // Debug logs - show which extensions are allowed
      console.log("Allowed extensions:", allowedExtensions);
      console.log("Files being processed:", acceptedFiles.map(f => ({ name: f.name, type: f.type })));
      
      acceptedFiles.forEach((file) => {
        const fileSizeValid = file.size <= maxFileSize;
        const fileExtension = file.name.split(".").pop()?.toLowerCase() ?? "";
        const fileMimeType = file.type.toLowerCase();
        const fileExtensionValid = allowedExtensions.includes(fileExtension);
        const fileMimeTypeValid = allowedMimeTypes.includes(fileMimeType);
        
        console.log(`File validation for ${file.name}:`, {
          extension: fileExtension,
          mime: fileMimeType,
          sizeValid: fileSizeValid,
          extensionValid: fileExtensionValid,
          mimeValid: fileMimeTypeValid
        });
        
        // Always collect validation errors for notification
        if (!fileSizeValid) {
          errorMessages.push(`${file.name} exceeds the max file size limit of ${(maxFileSize / (1024 * 1024)).toFixed(2)} MB.`);
        }
        if (!fileExtensionValid) {
          errorMessages.push(`${file.name} has an invalid file extension. Allowed: ${allowedExtensions.join(", ")}.`);
        }
        if (!fileMimeTypeValid) {
          errorMessages.push(`${file.name} has an invalid MIME type. Allowed: ${allowedMimeTypes.join(", ")}.`);
        }
  
        // Only add valid files to newFiles
        if (fileSizeValid && fileExtensionValid && fileMimeTypeValid) {
          const newFile: UploadedFile = {
            id: `${file.name}-${Date.now()}`,
            file,
            preview: URL.createObjectURL(file),
            url: `${file.name}`,
            size: `${(file.size / (1024 * 1024)).toFixed(2)} MB`,
          };
  
          newFiles.push(newFile);
        }
      });
  
      // Show ALL error messages (even if some files are valid)
      if (errorMessages.length > 0) {
        console.log("Validation errors:", errorMessages);
        errorMessages.forEach((error) => {
          NotificationManager.error(error, "Validation Error", 5000);
        });
      }
  
      // Continue only if we have valid files
      if (newFiles.length === 0) {
        if (errorMessages.length === 0) {
          // This shouldn't happen normally, but just in case
          NotificationManager.error("No valid files to upload.", "Warning", 3000);
        }
        return;
      }
  
      // Upload valid files
      const newUploadingState = newFiles.reduce((acc, file) => {
        acc[file.id] = true;
        return acc;
      }, {} as Record<string, boolean>);
  
      setUploadingFiles((prev) => ({ ...prev, ...newUploadingState }));
      setUploadedFiles((prevFiles) => [...prevFiles, ...newFiles]);
  
      // Call the upload function after file selection
      handleUploadClick(newFiles).catch((err) => {
        console.error("Upload failed:", err);
        NotificationManager.error("Failed to upload files. Please try again.", "Upload Error", 5000);
      });
    },
    [maxFileSize, allowedExtensions, allowedMimeTypes, uploadedFiles, maxFileCount]
  );
  

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    onDrop,
    accept: allowedMimeTypes.length > 0 
      ? allowedMimeTypes.reduce((acc, mime) => ({ ...acc, [mime]: [] }), {})
      : undefined, // Fall back to accepting all files if no mimes specified
    multiple: true,
    noClick: false,
    noKeyboard: false,
    preventDropOnDocument: true,
    // Override the default validator to catch files earlier
    validator: (file) => {
      const fileExtension = file.name.split(".").pop()?.toLowerCase() ?? "";
      const fileMimeType = file.type.toLowerCase();
      
      if (!allowedExtensions.includes(fileExtension)) {
        return {
          code: "file-invalid-type",
          message: `File type .${fileExtension} is not accepted`
        };
      }
      
      if (!allowedMimeTypes.includes(fileMimeType)) {
        return {
          code: "file-invalid-type",
          message: `MIME type ${fileMimeType} is not accepted`
        };
      }
      
      if (file.size > maxFileSize) {
        return {
          code: "file-too-large",
          message: `File is larger than ${(maxFileSize / (1024 * 1024)).toFixed(2)} MB`
        };
      }
      
      return null;
    }
  });

const handleImagePreviewShow = (url: string): void =>{
  setShowImagePreviewModal(true);
  setPreviewImageUrl(url);
}
const handleImagePreviewClose = (): void =>{
  setShowImagePreviewModal(false);
  setPreviewImageUrl("");
}
const handleUploadClick = async (files: UploadedFile[]): Promise<void> => {
  console.log(1122222);
  console.log(files);
  if (files.length === 0) {
    NotificationManager.error("No files to upload.");
    return;
  }

  // ✅ Ensure single-upload file limit is respected
  if (files.length > maxFileCount) {
    NotificationManager.error(`You can only upload up to ${maxFileCount} images per upload.`);
    return;
  }

  for (const file of files) {
    if (!file.file) continue;

    setUploadingFiles((prev) => ({ ...prev, [file.id]: true }));
    console.log("file.file.name",file.file.name, file.id);
    const formData = new FormData();
    formData.append("templateImages", file.file, file.file.name);

    try {
           const templateVersion = templateActiveVersionData ?? 1;
      const response = await updatetemplateimages(formData, templateGuid ?? "",templateVersion, user?.id ?? 1);

      if (response.status === 200) {
        const uploadedFileName = file.file.name;
        const cacheBuster = `?v=${Date.now()}`;
        const uploadedUrl = `${imagePublicUrl}Template/${templateGuid}/${templateVersion}/${uploadedFileName}${cacheBuster}`;
        // const uploadedUrl = `${imagePublicUrl}Template/${templateGuid}/${templateVersion}/${uploadedFileName}`;

        // setFormattedExistingImages((prev) =>
        //   prev.map((existingFile) =>
        //     existingFile.id === file.id
        //       ? { ...existingFile, url: uploadedUrl, preview: uploadedUrl }
        //       : existingFile
        //   )
        // );

        
        setFormattedExistingImages((prev) => {
          const newFileName = file.file?.name ?? file.id.split('/').pop();
          // Remove any existing file with the same name
          const filtered = prev.filter(existingFile => {
            const existingFileName = existingFile.file?.name ?? existingFile.id.split('/').pop();
            return existingFileName !== newFileName;
          });
          // Prepend the updated file
          return [{ ...file, url: uploadedUrl, preview: uploadedUrl }, ...filtered];
        });
      }
    } catch (error) {
      console.error("Upload error:", error);
      NotificationManager.error(`Error uploading ${file.file.name}.`);
    } finally {
      setUploadingFiles((prev) => ({ ...prev, [file.id]: false }));
    }
  }

  setUploadedFiles([]);
};



  const columns = [
    {
      name: "Image",
      selector: (row: UploadedFile) => row.preview,
      cell: (row: UploadedFile) => (
        <div style={{ position: "relative", width: "50px", height: "50px" }}>
            <BootstrapTooltip title={row.url} >
              <span>
          <div
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              background: uploadingFiles[row.id] ? "rgba(255,255,255,0.5)" : "transparent", // ✅ Dim background when uploading
              zIndex: 1,
            }}
          />
          
          {uploadingFiles[row.id] && (
            <div
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 2, // ✅ Ensure loader is in front
              }}
            >
              <CircularProgress size={30} thickness={5} sx={{ color: '#ED4B52' }} />
            </div>
          )}
    
          <img
            src={row.preview}
            alt="preview"
            className="w-10 h-10 object-cover rounded-md"
            style={{
              opacity: uploadingFiles[row.id] ? 0.5 : 1, // ✅ Dim the image if it's uploading
            }}
          />
</span>
          </BootstrapTooltip>
        </div>
      ),
      width: "20%",
    },  
    {
      name: "URL",
      selector: (row: UploadedFile) => row.url,
      cell: (row: UploadedFile) =>  {
        const [tooltipText, setTooltipText] = useState("Copy");
  
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        const handleCopyToken = (token: string) => {
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          navigator.clipboard.writeText(token);
          setTooltipText("Copied!"); // Change tooltip to "Copied!"
          setTimeout(() => setTooltipText("Copy"), 1500); // Reset after 1.5s
        }; 
        return (
          <div className="flex items-center" >
        <a   target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline truncate block  max-w-[300px]  text-[#3A3A3A]">
          {row.url}
          </a>
          <div className="icon-hover-container" >
          <BootstrapTooltip title={tooltipText} >
                    <IconButton
                      onClick={() => handleCopyToken(row.url)}
                    >                      
                      <HugeiconsIcon
                      icon={Copy01StrokeStandard}
                      size={20}
                      color="currentcolor"
                      strokeWidth={0.2}
                      /> 
      
                    </IconButton>
                  </BootstrapTooltip>
                  </div>
       </div>
      )
    },
      wrap: true,
      width: "60%",
    },
    {
      name: "Size",
      selector: (row: UploadedFile) => row.size,
      cell: (row: UploadedFile) => <span className="text-gray-600">{(row.size !== "") && row.size !== "Unknown Size" ? row.size : ''}</span>,
      width: "20%",
    },
   
  ];
  const imageDatacolumns = [
   {
  name: "Image",
  cell: (row: imageDataFile) => {
    const [imageError, setImageError] = useState(false);

    useEffect(() => {
      setImageError(false); // Reset when image URL changes
    }, [row.preview]);

    const hasValidImage = !imageError && row.preview;

    return (
      <div
        style={{
          position: "relative",
          width: "40px",
          height: "40px",
          borderRadius: "8px",
          overflow: "hidden",
          backgroundColor: "#F3F4F6", // fallback bg
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: hasValidImage ? "pointer" : "default"
        }}
        onClick={hasValidImage ? () => handleImagePreviewShow(row.url) : undefined}
      >
        <BootstrapTooltip title={row.url}>
          <span style={{ display: "flex", width: "100%", height: "100%", position: "relative" }}>
            {/* Image preview */}
            {hasValidImage && (
              <img
                src={row.preview}
                alt={row.alt}
                onError={(e) => {
                  setImageError(true);
                  e.currentTarget.style.display = 'none';
                }}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "8px",
                  zIndex: 2
                }}
              />
            )}

            {/* Fallback icon if image fails */}
            {imageError && (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 2
                }}
              >
                <HugeiconsIcon
                  icon={Image02Icon}
                  size={32}
                  color="#9CA3AF"
                />
              </div>
            )}

            {/* Show eye icon only if image is valid */}
            {hasValidImage && (
              <div
                className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity"
                style={{ borderRadius: '8px', zIndex: 3 }}
              >
                <HugeiconsIcon
                  icon={ViewStrokeRounded}
                  size={24}
                  color="white"
                  strokeWidth={0.5}
                  className="cursor-pointer"
                />
              </div>
            )}
          </span>
        </BootstrapTooltip>
      </div>
    );
  },
  width: "20%",
},
    {
      name: "URL",
      selector: (row: imageDataFile) => row.url,
      cell: (row: imageDataFile) => {
        const [tooltipText, setTooltipText] = useState("Copy");
        const [isEditing, setIsEditing] = useState(false);
        const [tempUrl, setTempUrl] = useState(row.url);
        const [isError, setIsError] = useState(false); 
        
        const handleEdit = (): void => {
          setIsEditing(true);
          setIsError(false); // Reset error when editing starts
        };
        
        const handleCancel = (): void => {
          setIsEditing(false);
          setTempUrl(row.url);
          setIsError(false); // Reset error on cancel
        };
        
        const handleSave = (): void => {
          if (tempUrl.trim() === "") {
            setIsError(true); // Show red background
            NotificationManager.error("Please provide a valid URL");
            return;
          }
        
          setIsEditing(false);
          const oldUrl = row.url;
        
          // Update both the URL and preview in the newImagData state
          setNewImagData((prevData) =>
            prevData.map((item) =>
              item.id === row.id ? { ...item, url: tempUrl, preview: tempUrl } : item
            )
          );
        handleReplaceAll('urlEdit',oldUrl, tempUrl);
          // // Update the content in the editor
          // if (updateEditorContent) {
          //   updateEditorContent(oldUrl, tempUrl);
          // }
        };
        
        // Rest of your component remains the same
        return (
          <div className="flex items-center">
            {isEditing ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  width: "100%",
                }}
              >
                <TextField
                  fullWidth
                  autoComplete="off"
                  label="URL*"
                  placeholder="Enter new URL"
                  value={tempUrl}
                  onChange={(e) => {
                    setTempUrl(e.target.value);
                    setIsError(false); // Reset error when typing
                  }}
                  inputProps={{ maxLength: 500 }}
                  sx={{
                    flex: 1.5,
                    minWidth: "280px",
                    backgroundColor: isError ? "#FFEBEE" : "white"
                  }}
                  error={isError} 
                />
         <BootstrapTooltip title={SAVE_TEMPLATE} >
                <IconButton onClick={handleSave} sx={{  "&:hover": { color: "#06A864" }  }} className="ml-1">
                  <HugeiconsIcon icon={Tick02Icon} size={20} strokeWidth={0.2} />
                </IconButton>
                </BootstrapTooltip>
                
                <BootstrapTooltip title={CANCEL_TEMPLATE} >
                <IconButton onClick={handleCancel} sx={{ "&:hover": { color: "#ED4B52"  }}}>
                  <HugeiconsIcon icon={Cancel01Icon} size={20} strokeWidth={0.2}  />
                </IconButton>
                </BootstrapTooltip>
               
              </div>
            ) : (
              <>
                <a
                  href={row.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline truncate block max-w-[320px]  text-[#3A3A3A]"
                >
                  {row.url}
                </a>
               
                <div className="icon-hover-container" >
                <BootstrapTooltip title={EDIT_TEMPLATE} >
                <div onClick={handleEdit} >
                  <img src="/assets/images/icons/EditIcon.svg" width={18} height={18} alt="Edit" />
                </div>
                </BootstrapTooltip>
                </div>
                  {replacedImageIds.includes(row.id) && (
                <img
                  src="/assets/icons/GreenTickIcon.svg"
                  alt="Replaced"
                  className="w-4 h-4"
                />
              )}
              </>
            )}
          </div>
        );
        
      },
      wrap: true,
      width: "60%",
    },
    {
      name: "Alt Text",
      selector: (row: imageDataFile) => row.alt,
      cell: (row: imageDataFile) => (
        <span className="text-gray-600 truncate max-w-[120px]">{row.alt }</span>
      ),
      width: "20%",
    }
  ];
//   const handleReplaceAll = (): void => {
//   if (mergedFiles.length === 0) return;

//   const newImages = [...newImagData];
//   const replacedIds: string[] = [];
//   const replacements: { oldUrl: string; newUrl: string }[] = [];

//   for (let i = 0; i < Math.min(mergedFiles.length, newImages.length); i++) {
//     const uploaded = mergedFiles[i];
//     const oldImage = newImages[i];

//     if (oldImage.url !== uploaded.url) {
//       replacedIds.push(oldImage.id);
//       replacements.push({ oldUrl: oldImage.url, newUrl: uploaded.url });
//       newImages[i] = { ...oldImage, url: uploaded.url, preview: uploaded.url };
//     }
//   }
//   setReplacedImageIds(replacedIds);
//   setNewImagData(newImages);
//   setEditorReplacements(replacements); // store for applying later
// };

const handleReplaceAll = (type = '', oldUrl = '', newUrl = ''): void => {
  if (!newImagData.length) return;

  const updatedImages: imageDataFile[] = [];
  const replacedIds: string[] = [...replacedImageIds];
  let replacements = [...editorReplacements];

  // Handle manual URL edit
  if (type === 'urlEdit' && oldUrl && newUrl) {
    const updated = newImagData.map((image) => {
      if (image.url === oldUrl) {
        if (!replacedIds.includes(image.id)) replacedIds.push(image.id);
        return { ...image, url: newUrl, preview: newUrl };
      }
      return image;
    });

    // Remove any prior mapping with same oldUrl
    replacements = replacements.filter(r => r.oldUrl !== oldUrl);
    
    // Add new replacement
    replacements.push({ oldUrl, newUrl });

    setNewImagData(updated);
    setReplacedImageIds(replacedIds);
    setEditorReplacements(replacements);
    return;
  }

  // Handle "Replace All" button click
  if (!mergedFiles.length) return;

  console.log("New Image Data:", newImagData, mergedFiles);

  newImagData.forEach((original) => {
    const originalFileName = original.url.split('/').pop()?.toLowerCase().split('?')[0] ?? '';
    const matched = mergedFiles.find((uploaded) => {
      const uploadedFileName = uploaded.url.split('/').pop()?.toLowerCase().split('?')[0] ?? '';
      return uploadedFileName === originalFileName; // Full filename with extension
    });

    console.log('Matched File:', matched, original);

    if (matched && matched.url !== original.url) {
      if (!replacedIds.includes(original.id)) replacedIds.push(original.id);
      updatedImages.push({
        ...original,
        url: matched.url,
        preview: matched.url,
      });

      replacements = replacements.filter(r => r.oldUrl !== original.url);
      replacements.push({ oldUrl: original.url, newUrl: matched.url });
    } else {
      updatedImages.push(original);
    }
  });

  setNewImagData(updatedImages);
  setReplacedImageIds(replacedIds);
  setEditorReplacements(replacements);
};

const getCurrentLoggedInUserId = (): number => {
  try {
    const storedUser = localStorage.getItem('user');
    if (!storedUser) return 0;
    const parsedUser = JSON.parse(storedUser) as { id?: number | string };
    const id = Number(parsedUser?.id ?? 0);
    return Number.isFinite(id) ? id : 0;
  } catch {
    return 0;
  }
};

const handleCancelAll = (): void => {
  if (isProcessing) {
    return;
  }
  setNewImagData(originalImageDataRef.current);
  closeModal();
};

const handleSaveAll = async (): Promise<void> => {
  if (isProcessing) {
    return;
  }

  if (!updateEditorContent || !editorContent) {
    closeModal();
    return;
  }

  // 💾 Create final url map: original editor URL → final chosen URL
  const originalToFinalMap = new Map<string, string>();

  // First, add all manual edits from editorReplacements
  editorReplacements.forEach(({ oldUrl, newUrl }) => {
    originalToFinalMap.set(oldUrl, newUrl);
  });

  // Then, add file-based replacements (these won't override manual edits due to Map behavior)
  originalImageDataRef.current.forEach(originalImg => {
    // Skip if already manually replaced
    if (originalToFinalMap.has(originalImg.url)) {
      return;
    }

    const originalFileName = originalImg.url.split('/').pop()?.toLowerCase().split('?')[0] ?? "";

    const replacement = newImagData.find(newImg => {
      const newFileName = newImg.url.split('/').pop()?.toLowerCase().split('?')[0] ?? "";
      return newFileName === originalFileName; // Full filename with extension
    });

    if (replacement && replacement.url !== originalImg.url) {
      originalToFinalMap.set(originalImg.url, replacement.url);
    }
  });

  // Only proceed if there are actual changes
  if (originalToFinalMap.size === 0) {
    closeModal();
    return;
  }

  // 💡 Update only img src attributes in the HTML string
  let updatedContent = editorContent;

  originalToFinalMap.forEach((newSrc, oldSrc) => {
    const escapedOldSrc = oldSrc.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    const imgRegex = new RegExp(
      `(<img[^>]*\\s+src=["'])${escapedOldSrc}(["'][^>]*>)`,
      "gi"
    );

    updatedContent = updatedContent.replace(imgRegex, `$1${newSrc}$2`);

    console.log(`✅ Updated in HTML: ${oldSrc} ➜ ${newSrc}`);
  });

  if (updatedContent !== editorContent) {
    updateEditorContent(updatedContent);
  }

  setReplacedImageIds([]);
  setEditorReplacements([]);

  // Trigger AI Validation after image update
  setAiValidationInProgress(true);
  try {
    const composedTemplateId = templateIdentifier ?? localStorage.getItem("templateGuid") ??'';
    
    console.log(`[AI Validation] Starting validation for template: ${composedTemplateId} after image update`);
      try {
        try { await aiValidationWakeup(); } catch { /* wakeup is best-effort */ }

        const apiBase = (process.env.REACT_APP_API_BASE_URL ?? '').replace(/\/+$/, '');
        const callbackUrl = `${apiBase}/template/aivalidation/webhooks/validationdetails`;
        console.log(`[AI Validation] Submitting validation request to ${apiBase}`);

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const submitRes: any = await aiValidationValidateHtml({
          task: 'validate_html',
          html: updatedContent,
          templateId: composedTemplateId,
          callbackUrl,
          createdBy: getCurrentLoggedInUserId(),
        });

        console.log(`[AI Validation] Submit response:`, submitRes);
        NotificationManager.success('Images updated');
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (aiError: any) {
        console.error('[AI Validation] Error:', aiError);
        NotificationManager.error('Images updated but AI validation failed: ' + (aiError?.response?.data?.message ?? aiError?.message ?? 'Unknown error'));
      } finally {
        setAiValidationInProgress(false);
        closeModal();
      }
  } catch (error) {
    console.error('[AI Validation] Unexpected error:', error);
    setAiValidationInProgress(false);
    closeModal();
  }
};
  return (
    <React.Fragment>
      
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="relative px-[16px] pt-[10px]">
            <div className={`mb-[5px] w-full relative role-input-container disabled`} style={{ marginBottom: '30px' }}>
                                  <TextField
                                      id="outlined-basic"
                                      label={"Template Name"}
                                      variant="outlined"
                                      fullWidth
                                      value={TemplateName}
                                      autoComplete="off"
                                      InputProps={{
                                          style: {
                                              textAlign: "center",
                                              color: '#343434 !important',
                                              fontSize: '18px !important',
                                              fontWeight: '700 !important',
                                              WebkitTextFillColor: '#343434 !important',
                                              padding: '9px 14px 9px 25px'
                                          },
                                         
                                      }}
                                      sx={{
                                          '& input': {
                                              textAlign: 'center',
                                          },
                                          '& label': {
                                              textAlign: 'center',
                                          },
                                          backgroundColor: '#F5F5F5',
                                      }}
                                      disabled={true}
                                  />
                                  
                              </div>
                            


          {/* Drag and Drop Zone */}
          <div className="mb-[30px]">
            <div
              {...getRootProps({ className: "dropzone border-2 border-dashed p-6 text-center cursor-pointer" })}
              style={{ pointerEvents: isProcessing ? 'none' : 'auto', opacity: isProcessing ? 0.6 : 1 }}
            >
              <input {...getInputProps()} />
              {isDragActive ? <p>Drop the files here ...</p> : 
              <> <p>
                                 <span style={{ fontWeight: 600 }}>Drag and drop or</span>
                                    <span
                                      style={{
                                        color: '#007bff',
                                        cursor: 'pointer',
                                        fontWeight: 600,
                                      }}
                                    >
                                      {' '}
                                      Click here{' '}
                                    </span>
                                    <span style={{ fontWeight: 600 }}>to choose file</span>
                                  </p>

                                  <span
                                    style={{
                                      display: 'block',
                                      marginTop: '20px',
                                      fontSize: '12px',
                                      color: '#555'
                                    }}
                                  >
                                    { `Max size: ${maxFileSizeDisplay} MB. `}{' '}
                                    File format: {extensionsDisplay}
                                  </span>
                                  </>
                                  }
            </div>
          </div>
          {loading && (
      <div style={{ padding: '24px' }}>
      <div className='flex justify-center items-center relative top-[50%]'><span className="loading loading-spinner text-primary"></span></div>
    </div>
    )}
          {/* Uploaded Files Preview */}
          {!loading &&mergedFiles.length > 0 && (
            <div className="mb-[30px]">
              
              <div className="flex justify-between items-center mb-2 ">
      <h3 className="text-lg font-semibold text-[#3A3A3A]">Uploaded Images</h3>
    </div>
    <div className="border rounded-lg bg-white p-2" style={{ borderColor: '#E6ECF2' }}>
            <CustomDataTable
              columns={columns}
              data = {[...mergedFiles]} 
              selectableRows={false}
              pagination
              paginationPerPage={5}
              paginationRowsPerPageOptions={[5, 10, 15, 20, 25,30]}
            />
           </div>
            </div>
          )}
          
          {/* Display Existing Images (`newImagData`) */}
          {newImagData.length > 0 && (
            <div className="mb-[30px]">
                <div className="flex justify-between items-center mb-2">
    <h3 className="text-lg font-semibold text-[#3A3A3A]">External Images</h3>
    {formattedExistingImages.length > 0 && (
     
      <GradientButton
              color="red"
              onClick={handleReplaceAll}
              disabled={isProcessing}
              //@ts-ignore
              style={{
                fontSize: '12px',
                padding: '4px 10px',
                minWidth: 'auto',
                height: '28px',
              }}
            >
              Replace All
            </GradientButton>
    )}
  </div>
              
              <div className="border rounded-lg bg-white p-2" style={{ borderColor: '#E6ECF2' }}>
                <CustomDataTable
                  columns={imageDatacolumns}
                  data={newImagData}
                  selectableRows={false}
                  pagination
                  paginationPerPage={5}
                  paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
                />
              </div>
            </div>
          )}
        </div>
         <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
          <div className="w-full relative col-span-3">
            <button
              type="button"
              className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted"
              onClick={handleCancelAll}
              disabled={isProcessing}
            >
              {LABEL_BTN_CANCEL}
            </button>
          </div>
          <div className="w-full relative col-span-3">
            <button
              type="button"
              onClick={() => { void handleSaveAll(); }}
              disabled={isProcessing}
              className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]"
            >
             {isProcessing ? <span className="loading loading-spinner loading-xs text-white"></span> : 'Update Image'}
            </button>
          </div>
        </div>
      </form>
      {isProcessing && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(255, 255, 255, 0.55)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1300,
          }}
        >
          <span className="loading loading-spinner text-primary"></span>
        </div>
      )}
      <BootstrapDialog 
  onClose={handleImagePreviewClose} 
  aria-labelledby="customized-dialog-title" 
  open={showImagePreviewModal} 
  PaperProps={{  
    sx: {
      width: '75vw', // 75% of viewport width
      height: 'auto', // Auto height to accommodate content
      maxHeight: '75vh', // Max 75% of viewport height
      position: 'absolute',
      top: '10%' // Position higher on the screen
    },
  }}
>
  <DialogTitle sx={{ 
    m: 0, 
    p: 1.5,
    color: '#3A3A3A', 
    fontSize: '18px', 
    fontWeight: '600' 
  }} id="customized-dialog-title">
    {"Image Preview"}
  </DialogTitle>
  <IconButton 
    aria-label="close" 
    onClick={handleImagePreviewClose} 
    sx={{
      position: 'absolute',
      right: 8,
      top: 8,
      color: (theme) => theme.palette.grey[500],
    }}
  >
    <HugeiconsIcon
      icon={MultiplicationSignStrokeStandard}
      size={24}
      color="currentcolor"
      strokeWidth={0.5}
    /> 
  </IconButton>
  <DialogContent sx={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    overflow: 'hidden',
    pt: 0,
    pb: 2
  }}>
    {previewImageUrl !='' && (
      <img 
        src={previewImageUrl} 
        alt="Preview" 
        style={{ 
          maxWidth: '100%', 
          maxHeight: '100%',
          objectFit: 'contain' // Ensures image fits within container
        }} 
      />
    )}
  </DialogContent>
</BootstrapDialog>

    </React.Fragment>
  );
}

export default TemplateImageUpload;
